export default __webpack_public_path__ + "static/media/gallery-wip-pommel-neck_03.e53caefa.jpg";